<template>
  <div id="admin-user-extracts">
    <vue-headful :title="title + ($appName ? ' | ' + $appName : '')" />
    <ExtractJobs :extracts="extracts" :name="name" :busy="busy" />
  </div>
</template>

<style lang="scss">
@import "@/styles/common.scss";
</style>

<script>
import { EventBus } from "@/components/eventbus";
import ApiHelper from "@/helper/apihelper";
import ExtractJobs from "@/components/ExtractJobs";
import Console from "@/console";

export default {
  name: "admin-user-extracts",
  components: { ExtractJobs },
  created() {
    this.fetchData();
  },
  watch: {
    $route: "fetchData"
  },
  data() {
    return {
      title: "Extracts",
      extracts: [],
      name: null,
      busy: true
    };
  },
  methods: {
    async fetchData() {
      var userId = this.$route.params.userId;
      try {
        let client = await ApiHelper.http();
        var response = await client.get(
          `${ApiHelper.endPoint()}extracts?userId=${userId}&itemsPerPage=999`
        );

        if (response.data.status === "success") {
          Console.log(response.data.extracts);
          this.extracts = response.data.extracts;
          this.name = this.extracts[0].userEmail;
        } else {
          this.showWarning("There was a problem getting extracts.");
        }
      } catch {
        this.showWarning("There was a problem getting extracts.");
      } finally {
        this.busy = false;
      }
    },
    showWarning(message) {
      EventBus.$emit("show-toast", { message: message, variant: "warning" });
    }
  }
};
</script>